exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-wrapper[data-v-023b78ec] {\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n.handle[data-v-023b78ec] {\n  float: left;\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n", ""]);

// exports
